function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.258789 17C0.258789 18.6569 1.77575 20 3.64702 20H19.4588C21.3301 20 22.847 18.6569 22.847 17V3C22.847 1.34315 21.3301 0 19.4588 0H3.64702C1.77575 0 0.258789 1.34315 0.258789 3V17ZM20.5882 17C20.5882 17.5523 20.0825 18 19.4588 18H3.64702C3.02327 18 2.51761 17.5523 2.51761 17V3C2.51761 2.44772 3.02327 2 3.64702 2H9.29408V10.0111L11.999 10.0112L13.8118 7.86419L15.6245 10.0112H18.3295L18.3294 2H19.4588C20.0825 2 20.5882 2.44772 20.5882 3V17ZM16.0706 2H11.5529V7.33585L13.8118 4.66046L16.0706 7.33571V2Z",
  fill: "#4979C0"
});

var SvgMyAudit = function SvgMyAudit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyAudit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/myAudit.cda4c670.svg";
export { ForwardRef as ReactComponent };